import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AccountProvider } from './contexts/AccountContext';
import { AuthProvider } from './contexts/AuthContext';
import './index.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);

window.addEventListener('unhandledrejection', (event) => {
  // biome-ignore lint/suspicious/noConsole: We need to log unhandled rejections for debugging
  console.error('Unhandled promise rejection:', event.reason);
});

root.render(
  <React.StrictMode>
    <AuthProvider>
      <AccountProvider>
        <App />
      </AccountProvider>
    </AuthProvider>
  </React.StrictMode>
);
